import { FaLinkedin } from 'react-icons/fa';
import { MdClose, MdEmail } from 'react-icons/md';
import styles from './FeedbackModal.module.css';

const FeedbackModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className={styles.overlay} onClick={onClose}>
      <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
        <div className={styles.header}>
          <h2>Contact & Feedback</h2>
          <button 
            className={styles.closeButton}
            onClick={onClose}
            aria-label="Close feedback modal"
          >
            <MdClose />
          </button>
        </div>

        <div className={styles.content}>
          <div className={styles.infoSection}>
            <div className={styles.projectInfo}>
              <h3>SeleneDocs</h3>
              <p className={styles.subtitle}>BT4101 Final Year Project</p>
            </div>

            <div className={styles.contactInfo}>
              <h4>Get in Touch</h4>
              <p className={styles.text}>
                Have feedback, questions, or suggestions? I'd love to hear from you!
              </p>
              
              <div className={styles.emailSection}>
                <MdEmail className={styles.emailIcon} />
                <div className={styles.emailDetails}>
                  <span className={styles.label}>Email</span>
                  <a 
                    href="mailto:koiljat@u.nus.edu?subject=SeleneDocs Feedback" 
                    className={styles.emailLink}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    koiljat@u.nus.edu
                  </a>
                </div>
              </div>

              <div className={styles.emailSection}>
                <FaLinkedin className={styles.linkedinIcon} />
                <div className={styles.emailDetails}>
                  <span className={styles.label}>LinkedIn</span>
                  <a 
                    href="https://www.linkedin.com/in/koiljat/" 
                    className={styles.emailLink}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    linkedin.com/in/koiljat
                  </a>
                </div>
              </div>
            </div>

            <div className={styles.author}>
              <h4>Developed by</h4>
              <p className={styles.authorName}>Chong Koil Jat</p>
              <p className={styles.affiliation}>National University of Singapore</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FeedbackModal;
